import React from "react"
import ReactDOM from "react-dom"
import ManageBookingShortcutComponent from "./manage-booking-shortcut-component"

export default class ManageBookingShortcutModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ManageBookingShortcutComponent lang={document.body.dataset.language} {...self.modelJson} />, self.elem)
  }
}
